import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../../packages/api-models/common/json_query';

interface ITrackFilterFromChipsApplyArgs {
  queryString: string;
  pageType: 'Listing' | 'Map';
  jsonQuery: IJsonQuery;
}

export const trackNonGeoSearch = ({ queryString, pageType, jsonQuery }: ITrackFilterFromChipsApplyArgs) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'FastFilters',
    action: 'popup_confirm',
    label: queryString,
    page: { pageType, extra: { reason: 'geo' }, reason: 'expand_area_search' },
    sc: jsonQuery,
  });
};
